import styled from 'styled-components'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const SignIntro = styled.p`
	font-size: 1em;
	color: ${colorTheme.roomCharge.modal.label};
`
SignIntro.displayName = 'SignIntro'

export const SignIntroAccent = styled.span`
	font-weight: 600;
	color: ${colorTheme.roomCharge.modal.title};
`
SignIntroAccent.displayName = 'SignIntroAccent'

export const SignActions = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.62em;
`
SignActions.displayName = 'SignActions'
